module.exports = __webpack_public_path__ + "img/partner_img10.d7410ebc.png";